<template>
  <div id="contact">
    <section class="hero is-primary has-text-centered">
      <div class="hero-body">
        <div class="container">
          <h1 class="title mqu-title">
            Contact Us
          </h1>
        </div>
      </div>
    </section>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <h1 class="title mqu-subtitle">Please contact us with any feedback or comments you may have.</h1>
          <h1 class="subtitle">We are specifically interested in the following: any suggested improvements and if there are any details (e.g. fees and charges) in your contract that our calculator does not deal with. We will endeavour to contact you, if you provide your contact details (e.g. email address or phone number).</h1>
          <form @submit.prevent="submit">
            <b-field label="Email (Optional)"
                     :message="errors.has('email') ? errors.first('email') : ''"
                     :type="errors.has('email') ? 'is-danger' : ''">
              <b-input name="email" type="email" v-model="request.from" v-validate="'email'"></b-input>
            </b-field>
            <b-field label="Message"
                     :message="errors.has('message') ? errors.first('message') : ''"
                     :type="errors.has('message') ? 'is-danger' : ''">
              <b-input name="message" maxlength="1000" type="textarea" v-model="request.text" v-validate="'required'"></b-input>
            </b-field>
            <button class="button is-primary" type="submit">
              Send
            </button>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  data() {
    return {
      request: {
        from: null,
        subject: '[rvcalculator.mq.edu.au][contact-us]',
        text: null
      }
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.axios
            .post(`/api/mail`, JSON.parse(JSON.stringify(this.request)))
            .then(() => {
              this.$snackbar.open('Message sent, thank you for your feedback!')
            })
            .catch(e => {
              // eslint-disable-next-line
              console.log(e)
              this.$snackbar.open({
                message: 'Looks like something went wrong, please try again later.',
                type: 'is-danger'
              })
            })
        }
      })
    }
  }
}
</script>

<style scoped>
.mqu-title {
  font-family: 'National-Extrabold';
}

.mqu-subtitle {
  font-family: 'National-Light';
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Contact.vue